/**
 * A constant for the 'YYYY-MM-DD' format of a date string.
 */
export const DateOnlyFormat = 'YYYY-MM-DD';

/**
 * A type to represent a date string with format `YYYY-MM-DDTHH:mm:ss.sssZ`.
 */
export type DateWithTime = string;

/**
 * A type to represent a date string with format {@link DateOnlyFormat}.
 */
export type DateWithoutTime = string;

/**
 * A type to represent a Postgre time string with format `HH:MM:SS`.
 */
export type TimeWithoutDate = string;
